const getPartnerData = (rootState) => rootState.user.partnerData;

export default getPartnerData;
